import React, { useEffect, useMemo, useState } from "react";
import { fetchMedia } from "../lib/api";
import MediaGallery from "./MediaGallery";

/**
 * Public "Preuves d'envoi" section with tabs by transporteur / marketplace.
 * Only tabs that have at least one media item are displayed.
 */
const SECTIONS = [
  { key: "all", label: "Tous", flag: "" },
  { key: "colissimo", label: "Colissimo", flag: "📮" },
  { key: "colis_prive", label: "Colis Privé", flag: "🚚" },
  { key: "mondial_relay", label: "Mondial Relay", flag: "🏪" },
  { key: "tiktok_fr", label: "TikTok France", flag: "🇫🇷" },
  { key: "tiktok_it", label: "TikTok Italie", flag: "🇮🇹" },
  { key: "tiktok_es", label: "TikTok Espagne", flag: "🇪🇸" },
  { key: "general", label: "Divers", flag: "📦" },
];

const PreuvesEnvoi = ({ columns = 4 }) => {
  const [allItems, setAllItems] = useState([]);
  const [tab, setTab] = useState("all");

  useEffect(() => {
    fetchMedia({ category: "envois" })
      .then((data) => setAllItems(data || []))
      .catch(() => setAllItems([]));
  }, []);

  const countsBySection = useMemo(() => {
    const c = {};
    for (const s of SECTIONS) c[s.key] = 0;
    c.all = allItems.length;
    for (const m of allItems) {
      const k = m.subcategory || "general";
      c[k] = (c[k] || 0) + 1;
    }
    return c;
  }, [allItems]);

  // Only render tabs that have at least one item (except "all" which is always visible)
  const visibleTabs = SECTIONS.filter((s) => s.key === "all" || (countsBySection[s.key] || 0) > 0);

  if (allItems.length === 0) {
    return <MediaGallery category="envois" columns={columns} />;
  }

  return (
    <div data-testid="preuves-envoi-section">
      {visibleTabs.length > 1 && (
        <div className="flex flex-wrap gap-2 mb-8 justify-center" data-testid="preuves-envoi-tabs">
          {visibleTabs.map((s) => (
            <button
              key={s.key}
              onClick={() => setTab(s.key)}
              className={`px-4 py-2 label-caps text-[10px] tracking-[0.2em] transition-colors border ${
                tab === s.key
                  ? "border-[color:var(--gold)] bg-[color:var(--gold)]/10 text-[color:var(--gold)]"
                  : "border-white/15 text-white/60 hover:border-white/40 hover:text-white/90"
              }`}
              data-testid={`preuves-envoi-tab-${s.key}`}
            >
              {s.flag && <span className="mr-2">{s.flag}</span>}
              {s.label}
              <span className={`ml-2 text-[9px] ${tab === s.key ? "text-[color:var(--gold)]/70" : "text-white/40"}`}>
                {countsBySection[s.key] || 0}
              </span>
            </button>
          ))}
        </div>
      )}

      <MediaGallery
        key={tab}
        category="envois"
        subcategory={tab === "all" ? undefined : tab}
        columns={columns}
      />
    </div>
  );
};

export default PreuvesEnvoi;
